export class LogicalOperators {
  static negation(a: boolean): boolean {
    return !a;
  }
}
